<template>
  <section class="quota-section" :class="{exhausted: entry.status === 'EXHAUSTED'}" :aria-label="entry.title">
    <div class="quota-heading">
      <h3>{{ entry.title }}</h3>
      <strong v-if="balance && visibleQuota"><span>剩余 </span>{{ balance.value }}<small>{{ balance.unit }}</small></strong>
      <span v-else class="quota-state">{{ entry.status === 'DISABLED' ? '未开启' : '暂不可用' }}</span>
    </div>
    <template v-if="balance && visibleQuota">
      <div class="quota-meter" aria-hidden="true"><i :style="{width: balance.percent + '%'}" /></div>
    </template>
    <p v-if="entry.message" class="quota-message" role="status">{{ entry.message }}</p>
    <div v-if="period && visibleQuota" class="quota-period">
      <div v-for="row in period.rows" :key="row.label" class="quota-date"><span>{{ row.label }}</span><time :datetime="row.at">{{ row.value }}</time></div>
    </div>
  </section>
</template>
<script>
export default {
  props: { entry: { type: Object, required: true } },
  computed: {
    presentation() { return this.entry.presentation },
    balance() { return this.presentation && this.presentation.balance },
    period() { return this.presentation && this.presentation.period },
    visibleQuota() { return !['DISABLED', 'UNAVAILABLE'].includes(this.entry.status) }
  }
}
</script>
<style scoped>
.quota-section{padding:20px 0 4px;}.quota-section+.quota-section{margin-top:14px;border-top:1px solid #edf0f4;}
.quota-heading{display:flex;justify-content:space-between;align-items:baseline;gap:12px;flex-wrap:wrap;}
h3{font-size:14px;color:#303c50;font-weight:600;margin:0;}
strong{font-size:25px;font-weight:600;color:#303c50;font-variant-numeric:tabular-nums;line-height:1.3;}
strong span{font-size:12px;font-weight:400;color:#788292;}small{font-size:14px;margin-left:3px;}
.quota-state{font-size:12px;color:#788292;}
.quota-meter{margin:12px 0;height:5px;border-radius:4px;background:#edf0f5;overflow:hidden;}.quota-meter i{display:block;height:100%;border-radius:4px;background:#8198c5;}
.quota-date{display:flex;justify-content:space-between;align-items:baseline;gap:12px;padding:5px 0;font-size:12px;line-height:1.6;}.quota-date>span{color:#89919e;flex-shrink:0;}.quota-date time{color:#465164;text-align:right;font-variant-numeric:tabular-nums;}
.quota-message{font-size:12px;color:#788292;line-height:1.6;margin:10px 0;overflow-wrap:anywhere;}.exhausted strong,.exhausted .quota-message{color:#9a6a30;}
</style>
